var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEdit2 = function SvgEdit2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "edit-2_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.918 2.387c-.344.142-.655.35-.918.613L3.5 16.5 2 22l5.5-1.5L21 7a2.828 2.828 0 0 0-3.082-4.613Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgEdit2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTcuOTE3NiAyLjM4NjkzQzE3LjU3NDQgMi41MjkwNyAxNy4yNjI2IDIuNzM3NDEgMTcgMy4wMDAwNkwzLjUgMTYuNTAwMUwyIDIyLjAwMDFMNy41IDIwLjUwMDFMMjEgNy4wMDAwNkMyMS4yNjI2IDYuNzM3NDEgMjEuNDcxIDYuNDI1NjEgMjEuNjEzMSA2LjA4MjQ1QzIxLjc1NTMgNS43MzkyOSAyMS44Mjg0IDUuMzcxNDkgMjEuODI4NCA1LjAwMDA2QzIxLjgyODQgNC42Mjg2MiAyMS43NTUzIDQuMjYwODMgMjEuNjEzMSAzLjkxNzY3QzIxLjQ3MSAzLjU3NDUxIDIxLjI2MjYgMy4yNjI3IDIxIDMuMDAwMDZDMjAuNzM3NCAyLjczNzQxIDIwLjQyNTYgMi41MjkwNyAyMC4wODI0IDIuMzg2OTNDMTkuNzM5MiAyLjI0NDc5IDE5LjM3MTQgMi4xNzE2MyAxOSAyLjE3MTYzQzE4LjYyODYgMi4xNzE2MyAxOC4yNjA4IDIuMjQ0NzkgMTcuOTE3NiAyLjM4NjkzWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";